import axios from "axios";

const isDevEnv = process.env.NODE_ENV === "development";

function authHeader() {
  let userData = localStorage.getItem("user");
  if (userData) userData = JSON.parse(userData);
  else return {};

  if (userData.jwt) {
    return { Authorization: "Bearer " + userData.jwt };
  } else {
    return {};
  }
}

const Api = axios.create({
  headers: {
    common: authHeader(),
  },
  baseURL: isDevEnv
    ? "https://app.rattvisat.se/api"
    : "https://app.rattvisat.se/api",
});

export default Api;
